import { apiRequestGet } from 'mastodon/api';
import type { BotCommandNode } from 'mastodon/utils/bot_commands';

export interface ApiBotCommandsJSON {
  account_id: string;
  acct: string;
  commands: BotCommandNode[];
  updated_at: string | null;
}

export const apiLookupBotCommands = (acct: string) =>
  apiRequestGet<ApiBotCommandsJSON>('v1/custom/bot_commands/lookup', { acct });
